import { forwardRef } from 'react';
import classNames from 'classnames';
import type { LegendItem } from './spec-chart-render';
import styles from './chart-legend.module.scss';

/**
 * The shared multi-series legend row (swatch + label), rendered by both the catalog chart
 * (`SpecChart`) and the Custom builder (`CustomChart`). Pass the output of `buildLegend`
 * (from `spec-chart-render`); each item's `colorIndex` is its `SERIES_COLORS` palette slot,
 * index-aligned with the series `renderChartFamily` draws — the matching `.swatch{n}` class
 * lives in `chart-legend.module.scss`.
 *
 * Forwards a ref to the row element so content-export can rasterize the legend and stack it above
 * the chart image — the legend is a DOM sibling of the SciChart canvas, so it isn't captured with
 * the WebGL surface.
 */
export const ChartLegend = forwardRef<HTMLDivElement, { items: LegendItem[] }>(
  ({ items }, ref) => (
    <div ref={ref} className={styles.legend}>
      {items.map((item, i) => (
        <span key={`${item.label}-${i}`} className={styles.item}>
          <span
            className={classNames(
              styles.swatch,
              styles[`swatch${item.colorIndex}`]
            )}
          />
          {item.label}
        </span>
      ))}
    </div>
  )
);
ChartLegend.displayName = 'ChartLegend';
